module.exports = __webpack_public_path__ + "img/shape-2.96ad52bc.svg";